/* eslint-disable */
import axios from "axios";
import jwt_decode from "jwt-decode";
import store from "../../store/index";
import customModal from '../customModal/customModal.vue';


export default {
  name: "ApproveRejectPopUp",
  props: {
    formPage:{
      type: String,
      default: "",
    },
    actionType: {
      type: String,
      default: "",
    },
    itemId: {
      type: String,
      default: "",
    },
    version: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      baseurl: process.env.VUE_APP_Service_URL,
      head: {},
      token: store.getters.getIdToken,
      logedInUser: {},
      status: "",
      localComments: "",
      title: "Approval",
      action1:"Approve",
      action2:"Reject",
      apiUrl : "",
      payload : {},
      alertMsg : "",
    };
  },
  components: {
    customModal,
  },
  async mounted() {
    console.log("Approve Reject Popup mounted", this.actionType);
    this.head = {
      headers: {
        Authorization: "Bearer " + this.token,
        "Content-Type": "application/json",
      },
    };
    await this.getLogedInUser();
  },

  methods: {
    async close() {
      this.$emit("closeApproveModal");
    },
    async getLogedInUser() {
      this.logedInUser = jwt_decode(store.getters.getIdToken);
    },
    async ActionSubmit(actionBool){
      await this.setPrerequisites(actionBool);
      await this.callApi();
      await this.close();
    },
    async setPrerequisites(actionBool) {
      if (this.actionType === "Approval") {
        this.title = "Approval";
        this.action1="Approve"
        this.action2="Reject"
        this.apiUrl = `${this.baseurl}/management/study/changeversionstatus`;
        this.payload = {
              "studyId": this.itemId,
              "version": this.version,
              "approvedByEmail": this.logedInUser.email,
              "approvedStatus": actionBool == true ? "Approved" : "Rejected",
              "actionType": this.actionType == "Approval" ? "approvereject" : "activate",
              "comments": this.localComments
        };
        this.alertMsg = actionBool == true ? "Study approved successfully" : "Study rejected successfully";
      }
    },
    async callApi() {
        try{
          const result =  await axios.put(this.apiUrl, this.payload, this.head);
          console.log("API call result:", result);
          alert(this.alertMsg);
        }
        catch(error){
          console.error("API call error:", error);
        }
    }
  }
};

  